import React from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";
import {
  emailAddToBodyOrSubjectOptions,
  emailSelectOptions,
} from "../../../../../../assets/data/projectData";

const TwoWaySyncMails = () => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      from: "",
      to: "",
      selectName: "",
      addToBodyOrSubject: "",
      includeAlternateEmail: [],
      subject: "",
      body: "",
    },
    {
      selectName: {
        type: "select",
        required: true,
      },
    }
  );

  const handleSend = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form saved successfully:", formData);
    } else {
      console.log("errors : ", errors);
    }
  };

  // const handleAdd = () => {
  //   const { selectName, addToBodyOrSubject } = formData;
  //   if (!selectName || !addToBodyOrSubject) return;

  //   let targetField = "body";
  //   if (addToBodyOrSubject === "Add to Subject") {
  //     targetField = "subject";
  //   }

  //   handleChange(targetField, formData[targetField] + " " + selectName);
  // };
  const handleAdd = () => {
    const { selectName, addToBodyOrSubject } = formData;
    if (!selectName || !addToBodyOrSubject) return;

    if (addToBodyOrSubject === "Add to Subject") {
      handleChange("subject", selectName);
      handleChange("body", "");
    } else {
      handleChange("body", selectName);
      handleChange("subject", "");
    }
  };

  return (
    <div>
      <div>
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle
                title={"NEW MESSAGE"}
                icon={"mark_as_unread"}
                tag="p"
              />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="mt-6">
        <div className="flex gap-4 items-center">
          <p>From</p>
          <div className="w-[20%]">
            <FormFieldSet
              title=""
              type="select"
              placeholder="notifications@mail.com"
              value={formData.from}
              onChange={(value) => handleChange("from", value)}
              error={errors.from}
              options={[{
                label:"john.smith@ibm.com",
                value:"john.smith@ibm.com"
              },
            {
              label:"ryan.james@cisco.com",
              value:"ryan.james@cisco.com"
            }]}
            />
          </div>
        </div>
        <div className="flex mt-6 justify-between">
          <div className="flex gap-6">
            <p>To</p>
            <div>Ramesh Manthri</div>
          </div>
          <div className="text-primary">Cc Bcc</div>
        </div>
        <Divider />
        <div className="grid grid-cols-3 gap-x-6 mt-6 max-w-6xl items-start">
          <FormFieldSet
            title=""
            type="select"
            placeholder="Select"
            value={formData.selectName}
            onChange={(value) => handleChange("selectName", value)}
            error={errors.selectName}
            options={emailSelectOptions}
          />
          <FormFieldSet
            title=""
            type="select"
            placeholder="Select"
            value={formData.addToBodyOrSubject}
            onChange={(value) => handleChange("addToBodyOrSubject", value)}
            error={errors.addToBodyOrSubject}
            options={emailAddToBodyOrSubjectOptions}
          />
          <div className="mt-5">
            <Button title={"Add"} onClick={handleAdd} />
          </div>
        </div>
        <div className="flex justify-between mt-6">
          <div>
            <FormFieldSet
              type="text"
              title=""
              placeholder="Subject"
              value={formData.subject}
              onChange={(value) => handleChange("subject", value)}
              error={errors.subject}
            />
          </div>
          <div>
            <FormFieldSet
              type="checkbox"
              size={"md"}
              title={""}
              options={[
                {
                  label: "Include alternate email",
                  value: true,
                },
              ]}
              values={formData.includeAlternateEmail || []}
              onChange={(value) => handleChange("includeAlternateEmail", value)}
              multiple
              error={errors.includeAlternateEmail}
            />
          </div>
        </div>
        <Divider />
        <div className="mt-6 min-h-[400px]">
          <FormFieldSet
            type="textArea"
            title=""
            placeholder="body"
            value={formData.body}
            onChange={(value) => handleChange("body", value)}
            error={errors.body}
            className="min-h-[400px]"
          />
        </div>
        <div className="bg-neutral-100 rounded-sm flex p-1 justify-between">
          <div className="flex gap-2">
            <Button
              color="info"
              title={"Send"}
              size="sm"
              onClick={handleSend}
            />
            <Button
              color="black"
              title={"Save As Template"}
              size="sm"
              variant="outlined"
            />
            <Button
              color="black"
              size="sm"
              variant="text"
              type={"icon"}
              icon={"attach_file"}
            />
            <Button
              color="black"
              size="sm"
              variant="text"
              type={"icon"}
              icon={"attach_file"}
            />
          </div>
          <div>
            <Button type="icon" icon="delete" color="black" variant="text" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoWaySyncMails;
